module.exports = __webpack_public_path__ + "img/eye-solid.c8703ac9.svg";